var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import Api from '../model/api';
import AccsModule from '../module/accs';
import SessionDbModule from '../module/session-db';
import SessionListModule from '../module/session-list';
import UserModule from '../module/user';
import Emitter from '../utils/emitter';
import { decorator } from '../utils/instance';
import LogMsgTool, { mtopMsgToLog, SyncMtopLogKey } from '../utils/log-msg';
var syncKey = 'im';
var fetchCount = 50;
var Sync = (function (_super) {
    __extends(Sync, _super);
    function Sync(config) {
        var _this = _super.call(this) || this;
        _this.syncStatus = 0;
        _this._tmpNewSyncId = 0;
        _this._lastSyncId = 0;
        _this.config = config;
        _this._api = Api.getInstance(config);
        _this._user = UserModule.getInstance(config);
        _this._sess = SessionListModule.getInstance(config);
        _this._sessDb = SessionDbModule.getInstance(config);
        _this._accs = AccsModule.getInstance(config);
        LogMsgTool.init(config);
        return _this;
    }
    Sync.prototype.init = function () {
        var _sessDb = this._sessDb;
        if (_sessDb.syncId) {
            this.syncDataList(_sessDb.syncId, 1);
        }
        return Promise.resolve();
    };
    Sync.prototype.syncDataList = function (syncId, source) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _accs, _sessDb, config, _syncData, cb;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this, _accs = _a._accs, _sessDb = _a._sessDb, config = _a.config;
                if (source !== 1 && syncId <= _sessDb.syncId) {
                    return [2, Promise.resolve()];
                }
                if (this.syncStatus === 1) {
                    if (syncId > this._tmpNewSyncId)
                        this._tmpNewSyncId = syncId;
                    return [2, Promise.resolve()];
                }
                _syncData = function (syncId, source) { return __awaiter(_this, void 0, void 0, function () {
                    var param;
                    var _a;
                    return __generator(this, function (_b) {
                        this.syncStatus = 1;
                        param = {
                            namespace: _sessDb.syncNamespace,
                            widId: _accs.windowId || '',
                            source: source,
                            accountType: config.accountType,
                            dataTypeIdMap: JSON.stringify((_a = {},
                                _a[syncKey] = syncId,
                                _a)),
                            fetchSize: fetchCount,
                            sdkVersion: 1,
                        };
                        this._lastSyncId = syncId;
                        return [2, this._api.request(config._url.syncData, param)];
                    });
                }); };
                cb = function (resPacket) { return __awaiter(_this, void 0, void 0, function () {
                    var syncDataValuesMap, syncData, syncDataStatusMap, pages;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                syncDataValuesMap = (resPacket && resPacket.syncDataValuesMap) || {};
                                syncData = syncDataValuesMap[syncKey];
                                if (!(Array.isArray(syncData) && syncData.length)) {
                                    return [2, Promise.resolve()];
                                }
                                return [4, this._parseSyncList(syncData)];
                            case 1:
                                _a.sent();
                                syncDataStatusMap = resPacket.syncDataStatusMap || {};
                                pages = parseInt(syncDataStatusMap[syncKey]);
                                if (pages === -1) {
                                    if (this._tmpNewSyncId > _sessDb.syncId) {
                                        this._tmpNewSyncId = 0;
                                        return [2, _syncData(_sessDb.syncId, 0).then(cb)];
                                    }
                                }
                                else if (pages === 1) {
                                    return [2, _syncData(_sessDb.syncId, source).then(cb)];
                                }
                                else if (pages === 2) {
                                    return [2, Promise.reject('SYNC_FORCE_INIT')];
                                }
                                return [2, Promise.resolve()];
                        }
                    });
                }); };
                return [2, _syncData(_sessDb.syncId, source).then(cb).then(function () {
                        _this.syncStatus = 0;
                    }, function (err) {
                        _this.syncStatus = 0;
                        Promise.reject(err);
                    })];
            });
        });
    };
    Sync.prototype._parseSyncList = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _sess, _sessDb, tempSessionReqs, allPromise, msgItemArr, data_1, data_1_1, item, serializeType, syncBody, dataSerializeType, bizData, syncId, type, sessionPackets, prm;
            var e_1, _b;
            return __generator(this, function (_c) {
                _a = this, _sess = _a._sess, _sessDb = _a._sessDb;
                tempSessionReqs = [];
                allPromise = [];
                msgItemArr = [];
                try {
                    for (data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                        item = data_1_1.value;
                        serializeType = parseInt(item.serializeType);
                        syncBody = item.syncBody;
                        dataSerializeType = parseInt(syncBody.dataSerializeType);
                        bizData = void 0;
                        if (serializeType !== 1 || dataSerializeType !== 1) {
                            continue;
                        }
                        try {
                            bizData = JSON.parse(item.bizData);
                        }
                        catch (e) {
                            continue;
                        }
                        syncId = parseInt(syncBody.syncId);
                        type = parseInt(bizData.header.type);
                        if (type === 11 || type === 12) {
                            _sessDb.setAttr('syncId', syncId);
                            tempSessionReqs.push(bizData);
                        }
                        else if (type === 1 || type === 3 || type === 4) {
                            _sessDb.setAttr('syncId', syncId);
                            msgItemArr.push(bizData);
                            allPromise.push(this._parseSyncMessage(bizData));
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (data_1_1 && !data_1_1.done && (_b = data_1.return)) _b.call(data_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                LogMsgTool.saveSyncMsgCache(msgItemArr.map(mtopMsgToLog), SyncMtopLogKey);
                if (tempSessionReqs.length) {
                    sessionPackets = tempSessionReqs.map(function (req) { return req.body && req.body.typeData; });
                    prm = _sess.suppleUserData(sessionPackets, 'sync').then(function (sessionDataList) {
                        var e_2, _a;
                        try {
                            for (var sessionDataList_1 = __values(sessionDataList), sessionDataList_1_1 = sessionDataList_1.next(); !sessionDataList_1_1.done; sessionDataList_1_1 = sessionDataList_1.next()) {
                                var sessionData = sessionDataList_1_1.value;
                                if (sessionData.senderAccountType === 0) {
                                    delete sessionData.senderAccountType;
                                }
                                _sess.updateSessionByData(sessionData);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (sessionDataList_1_1 && !sessionDataList_1_1.done && (_a = sessionDataList_1.return)) _a.call(sessionDataList_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    });
                    allPromise.push(prm);
                }
                return [2, Promise.all(allPromise)];
            });
        });
    };
    Sync.prototype._parseSyncMessage = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _sess, _sessDb, _b, _c, typeData, sessionId, sessionData, sessionView, messageData;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this, _sess = _a._sess, _sessDb = _a._sessDb;
                        _b = data.body, _c = (_b === void 0 ? {} : _b).typeData, typeData = _c === void 0 ? {} : _c;
                        sessionId = typeData.sid;
                        sessionData = _sessDb.get(sessionId);
                        if (!sessionData) {
                            return [2];
                        }
                        sessionView = _sess.getSessionView(sessionId);
                        if (!sessionView) {
                            sessionView = _sess.createSessionView(sessionData);
                        }
                        return [4, sessionView.getParseMessage(data)];
                    case 1:
                        messageData = _d.sent();
                        sessionView.updateMsgData(messageData);
                        return [2];
                }
            });
        });
    };
    Sync = __decorate([
        decorator
    ], Sync);
    return Sync;
}(Emitter));
export default Sync;
